export default __webpack_public_path__ + "static/media/production-execution.97e699fe.svg";